import React from "react";
import { motion } from "framer-motion";
import { Inbox, Sparkles, PhoneCall, CheckCircle2 } from "lucide-react";

const KPI_DEFS = [
  { key: "total", label: "Total leads", icon: Inbox },
  { key: "new", label: "New", icon: Sparkles },
  { key: "contacted", label: "Contacted", icon: PhoneCall },
  { key: "funded", label: "Funded", icon: CheckCircle2 },
];

const KPI_TRANSITIONS = KPI_DEFS.map((_, i) => ({ delay: i * 0.06 }));
const kpiInitial = { opacity: 0, y: 20 };
const kpiAnimate = { opacity: 1, y: 0 };

export const KpiCards = ({ stats }) => (
  <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10">
    {KPI_DEFS.map((k, i) => (
      <motion.div
        key={k.key}
        initial={kpiInitial}
        animate={kpiAnimate}
        transition={KPI_TRANSITIONS[i]}
        className="bg-white rounded-2xl border border-[#E5E7EB] p-6"
        data-testid={`kpi-${k.label.toLowerCase().replace(/\s/g, "-")}`}
      >
        <k.icon size={20} className="text-[#052F24]/40 mb-4" />
        <div className="font-display font-extrabold text-4xl tracking-tighter">{stats[k.key]}</div>
        <p className="text-sm text-[#6B7280] mt-1">{k.label}</p>
      </motion.div>
    ))}
  </div>
);
